module.exports = __webpack_public_path__ + "h.no2.a2f30212.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/okuta/child_to_parent/h.no2.jpg
// module id = uNq0
// module chunks = 0